import styles from './Spinner.module.scss';

type Props = {
  className?: string;
  label?: string | null;
};

const Spinner = ({ className = '', label = '' }: Props) => (
  <>
    <span className={`${styles.spinner} ${className}`} />
    {label && <span className="visually-hidden">{label}</span>}
  </>
);

export default Spinner;
